import React from 'react';

import api from '../api/api';
import { ApiError } from '../error/error';

import type http from 'http';
import type { Response, Options } from '../api/api.types';
import type { Context, State, Props } from './app.types';

export const AppContext = React.createContext<Context>(undefined!);

export class AppProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.api = this.api.bind(this);
    this.activeGetRequests = {};

    this.state = {
      context: {
        api: this.api,
      },
    };
  }

  activeGetRequests: Record<string, any>;

  async api<T = any>(url: string, options?: Options, headers?: http.OutgoingHttpHeaders) {
    const method = options?.method || 'GET';

    try {
      if (method === 'GET' && this.activeGetRequests[url]) {
        const [response] = (await this.activeGetRequests[url]) as [Response<T>, Headers];
        return response;
      }

      const request = api<T>(url, options, headers);

      if (method === 'GET') {
        (this.activeGetRequests as Record<string, Promise<[Response<T>, Headers]>>)[url] = request;
      }

      const [response] = await request;

      return response;
    } catch (e: any) {
      if (e instanceof Error) {
        throw e;
      }
      throw new ApiError(e);
    } finally {
      if (method === 'GET') {
        delete this.activeGetRequests[url];
      }
    }
  }

  render(): JSX.Element {
    const { context } = this.state;
    const { children } = this.props;

    return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
  }
}
